import styled, { createGlobalStyle, keyframes } from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { CSS_CLASS } from 'components/Modal/constants'

const animation = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export const Wrapper = styled.div<any>`
  h1 {
    margin: 0 0 ${props => props.isSofia ? '90px' : '20px'};
    text-align: ${props => props.isSofia ? 'left' : 'center'};
    font: ${font('default', 'bold', '20px/1.3')};
    ${props => props.isSofia && `
      font-family: ${props.theme.font.alt.family};
      font-size: 30px;
      color: ${props.theme.palette.general.brown};
    `}
  }

  form {
    > div {
      padding-bottom: ${props => props.isSofia ? '15px' : '10px'};
    }
  }

  button {
    transition: all ease-in-out 0.3s;

    .spinner {
      left: 0;
      right: 0;
      top: 33%;
    }

    &.is-success {
      display: inline-flex;
      align-items: center;
      background-color: ${props => props.theme.palette.primary.beta};
      border-color: ${props => props.theme.palette.primary.beta};
      border-radius: 50%;
      width: 60px;
      height: 60px;

      > div {
        padding: 0;
      }

      svg {
        animation: ${animation} 0.8s linear forwards;
        fill: ${props => props.theme.palette.general.light};
      }
    }
  }

  .actions {
    display: flex;
    justify-content: ${props => props.isSofia ? 'center' : 'flex-end'};
    margin-top: ${props => props.isSofia ? '30px' : '20px'};

    button {
      ${props => props.isSofia && `
        padding: 10px 14px;
        font-size: 18px;
        background: ${props.theme.palette.general.brown};
        border-color: ${props.theme.palette.general.brown};

        &:hover {
          opacity: 0.8;
        }
      `}
    }
  }

  .input-wrapper {
    input {
      margin-right: 10px;
    }
  }
`

export const ModalGlobalStyle = createGlobalStyle<any>`
  .${CSS_CLASS.CONTENT_WRAP} {
    ${bp('sm', 'min-width')`
      width: 600px;
    `}
  }

  .${CSS_CLASS.CONTENT} {
    ${bp('sm', 'min-width')`
      padding: 20px 60px;
    `}
  }

  .${CSS_CLASS.CLOSE} {
    svg {
      fill: ${props => props.theme.palette.general.pinkLight};
      background: ${props => props.theme.palette.general.brown};
      border-color: ${props => props.theme.palette.general.brown};
    }
  }
`
